import {
    getData,
    postData,
    patchData,
    deleteData,
    putData
} from './Services'

export const getClientes = async () => {
    const res = await getData('/usuarios');
    return res
}


export const getClientesPanel= async (searchTerm,searchSel, page, perPage) => {
  let queryParams = [];
  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm || '')}`);
  } 
  if (searchSel) {
    queryParams.push(`emp_codigo=${encodeURIComponent(searchSel || '')}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }

  const queryString = queryParams.length > 0 ? `?}&${queryParams.join('&')}` : '';

  return await getData("/usuarios", queryString);
};

export const getClientesById = async (id) => {
    const res = await getData(`/usuarios/${id}`)
    return res
}

export const postClientes = async (body) => {
    const res = await postData('/usuarios', body)
    return res
}


export const patchPassword = async (body) => {
    const res = await putData(`/usuarios/updatePassword`,false, body); 
    return res
}

export const patchClientes = async (id, body) => {
    const res = await patchData(`/usuarios/${id}`, body)
    return res
}

export const accountClientes = async ( body) => {
    const res = await patchData(`/usuarios/actualizar/`, body)
    return res
}

export const forgotPasswordData = async (body) => {
    const res = await postData(`/usuarios/recuperar_contrasena`, body);
    return res;
}

export const deleteClientes = async (id) => {
    const res = await deleteData(`/usuarios/${id}`)
    return res
}

export const getDataFiscal = async (id) => {
    const res = await getData(`/usuarios/datosfiscal_user/${id}`)
    return res
}

export const getClienteByIdToken = async ({ email, token }) => {
    console.log("services",email, token)
  const res = await postData(`/usuarios/buscar`, { email, token });
  return res;
};

export const getTipoIva = async (id) => {
    const res = await getData(`/tipoiva`)
    return res
}

export const validateDataClient = async (body) => {
    console.log("services", body)
    const res = await postData(`/usuarios/validar_cliente`, body)
    console.log("services res", res)
    return res
}


export const resetAccountData = async (body) => {
    const res = await postData(`/usuarios/migrar_cuenta`, body);
    return res;
}